import React from 'react';
import {View} from 'react-native';

import FilterButton from '/component/base/FilterButton';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import VolumePerformanceTestIDs from '/constant/TestIDs/VolumePerformance';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from '../styles/VolumePerformanceContent.style';
import {VolPerfFiltersProps} from '../types/VolPerfComponent.types';

export const VolPerfFilters = ({
  frontlineOnly,
  onFrontlineToggle,
  onOpenModal,
  onClear,
  filterCount,
}: VolPerfFiltersProps) => {
  const {tt} = useTranslation('report.VolumePerformance');

  return (
    <View style={styles.filtersButtonContainer}>
      <View style={styles.viewContainer}>
        <FilterButton
          onPress={onFrontlineToggle}
          hideArrow={true}
          text={tt('frontline', 'Frontline Only')}
          testID={VolumePerformanceTestIDs.volPerfFrontlineOnlyButton}
          // @ts-expect-error TS(2322): Keep parity with MyTeams FilterButton usage
          style={styles.buttonWidth}
          active={frontlineOnly}
          disabled={false}
        />

        <TouchableOpacity
          testID={VolumePerformanceTestIDs.volPerfFiltersButton}
          accessible={true}
          accessibilityLabel={`${tt('filter', 'Filters')}${
            filterCount > 0 ? `, ${filterCount} active` : ''
          }`}
          accessibilityRole="button"
          style={[
            styles.buttonFilter,
            filterCount > 0 && styles.buttonFilterActive,
          ]}
          onPress={onOpenModal}>
          <Icon
            name={'filter'}
            style={[styles.iconReport, filterCount > 0 && styles.iconActive]}
          />

          <View style={styles.filterTextWrapper}>
            <Text
              style={[styles.text, filterCount > 0 && styles.textActive]}
              testID="reportSortButtonLabel">
              {tt('filter', 'Filters')}
            </Text>

            {filterCount > 0 && <View style={styles.filterDot} />}
          </View>
        </TouchableOpacity>
      </View>

      {filterCount > 0 && (
        <View style={styles.clearFilterRow}>
          <TouchableOpacity
            style={styles.clearFilterButton}
            onPress={onClear}
            accessible={true}
            accessibilityLabel={tt('clearFilters', 'Clear Filters')}
            accessibilityRole="button">
            <Text style={styles.clearFilterText} isBold>
              {tt('clearFilters', 'Clear Filters')}
            </Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

export default VolPerfFilters;
